import _ from 'lodash-es'

export const getIntersectionOfTwoArrays = (firstArray: Array<string | number | undefined>, secondArray: Array<string | number | undefined>) => {
  return _.intersection(_.compact(firstArray), _.compact(secondArray))
}
